"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var common_1 = require("stremio/common");
var debounce = require('lodash.debounce');
var DEBOUNCE_TIME = 300;
var PREVIEW_TIME = 1500;
var HOLD_ACCELERATION = 1.05;
var MAX_HOLD_STEP = 0.1;
var useKeyboardSeek = function (_a) {
    var time = _a.time, duration = _a.duration, onSeek = _a.onSeek, setSeeking = _a.setSeeking;
    var _b = (0, react_1.useState)(null), target = _b[0], setTarget = _b[1];
    var targetRef = (0, react_1.useRef)(null);
    var pendingRef = (0, react_1.useRef)(false);
    var holdStepRef = (0, react_1.useRef)(null);
    var timeRef = (0, common_1.useLiveRef)(time);
    var durationRef = (0, common_1.useLiveRef)(duration);
    var onSeekRef = (0, common_1.useLiveRef)(onSeek);
    var setSeekingRef = (0, common_1.useLiveRef)(setSeeking);
    var stopHold = (0, react_1.useCallback)(function () {
        holdStepRef.current = null;
    }, []);
    var move = (0, react_1.useCallback)(function (offset) {
        var _a;
        if (timeRef.current === null)
            return;
        var currentTime = (_a = targetRef.current) !== null && _a !== void 0 ? _a : timeRef.current;
        var target = Math.max(currentTime + offset, 0);
        var clampedTarget = durationRef.current !== null && !isNaN(durationRef.current) ?
            Math.min(target, durationRef.current)
            :
                target;
        targetRef.current = clampedTarget;
        pendingRef.current = true;
        setTarget(clampedTarget);
        setSeekingRef.current(true);
    }, []);
    var reset = (0, react_1.useCallback)(debounce(function () {
        targetRef.current = null;
        pendingRef.current = false;
        setTarget(null);
    }, PREVIEW_TIME), []);
    var commit = (0, react_1.useCallback)(debounce(function () {
        if (pendingRef.current && targetRef.current !== null) {
            pendingRef.current = false;
            onSeekRef.current(targetRef.current);
            setSeekingRef.current(false);
            reset();
        }
    }, DEBOUNCE_TIME), []);
    var cancel = (0, react_1.useCallback)(function () {
        var active = pendingRef.current;
        stopHold();
        commit.cancel();
        reset.cancel();
        targetRef.current = null;
        pendingRef.current = false;
        setTarget(null);
        if (active) {
            setSeekingRef.current(false);
        }
    }, []);
    var flush = (0, react_1.useCallback)(function () {
        stopHold();
        if (pendingRef.current) {
            commit();
        }
        commit.flush();
        setSeekingRef.current(false);
    }, []);
    var release = (0, react_1.useCallback)(function () {
        stopHold();
        if (pendingRef.current) {
            commit();
            requestAnimationFrame(commit.flush);
        }
    }, []);
    var seekTo = (0, react_1.useCallback)(function (time) {
        cancel();
        onSeekRef.current(time);
    }, []);
    var seekBy = (0, react_1.useCallback)(function (offset) {
        if (timeRef.current === null)
            return;
        reset.cancel();
        commit.cancel();
        if (holdStepRef.current === null) {
            holdStepRef.current = offset;
        }
        else if (Math.sign(holdStepRef.current) === Math.sign(offset)) {
            var duration_1 = durationRef.current;
            if (duration_1 !== null && !isNaN(duration_1) && duration_1 > 0) {
                holdStepRef.current = Math.sign(holdStepRef.current) * Math.min(Math.abs(holdStepRef.current) * HOLD_ACCELERATION, duration_1 * MAX_HOLD_STEP);
            }
        }
        else {
            return;
        }
        move(holdStepRef.current);
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        return function () {
            stopHold();
            commit.cancel();
            reset.cancel();
        };
    }, []);
    return {
        time: target,
        seekBy: seekBy,
        seekTo: seekTo,
        cancel: cancel,
        flush: flush,
        release: release,
    };
};
exports.default = useKeyboardSeek;
